import { useMatomo } from '@datapunt/matomo-tracker-react';
import { TrackEventParams } from '@datapunt/matomo-tracker-react/lib/types';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { EventActions, EventCategories, EventCustomDimensions } from '@models/analytics/Analytics';
import { FetchDocumentHeadersResponse } from '@models/documentHeaders/FetchDocumentHeaders';

interface CustomDimension {
    id: EventCustomDimensions;
    value: string;
}

interface CustomDimensions {
    administrationCode: CustomDimension;
    creditor: CustomDimension;
    environmentCode: CustomDimension;
    sourceDocId: CustomDimension;
}

interface TrackEventParamsV2 extends TrackEventParams {
    category: EventCategories;
    action: EventActions;
    customDimensions?: CustomDimension[];
}

const useTrackEvent = () => {
    const client = useQueryClient();
    const queryCache = client.getQueryCache();
    const { trackEvent: trackEventMatomo } = useMatomo();

    const trackEvent = (params: TrackEventParamsV2) => {
        trackEventMatomo({
            ...params,
        });
    };

    const getHeaderValueFromCache = (documentId: number, fieldId: string) => {
        const headers = queryCache.find<FetchDocumentHeadersResponse>({
            queryKey: [QueryKey.DocumentHeaders, documentId],
        });

        if (!headers?.state?.data?.values) {
            return '';
        }

        const field = headers.state.data.values.find((val) => val.id === fieldId);

        return (field?.value as string) || '';
    };

    const getCustomDimensions = (documentId: number): CustomDimensions => {
        return {
            administrationCode: {
                id: EventCustomDimensions.AdministrationCode,
                value: getHeaderValueFromCache(documentId, 'administratiecode'),
            },
            creditor: {
                id: EventCustomDimensions.Creditor,
                value: getHeaderValueFromCache(documentId, 'crediteur'),
            },
            environmentCode: {
                id: EventCustomDimensions.EnvironmentCode,
                value: 'todo',
            },
            sourceDocId: {
                id: EventCustomDimensions.SourceDocId,
                value: 'todo',
            },
        };
    };

    return {
        trackEvent,
        getCustomDimensions,
    };
};

export default useTrackEvent;
